import React from "react";
import classes from "./Features.module.css";
import { features } from "../../lib/Constants";
import FeatureCard from "./FeatureCard/FeatureCard";
import hero from "../../assets/images/features-hero.jpg";
import heroMobile from "../../assets/images/features-hero-mobile.jpg";
import bottomImg from "../../assets/images/feature-bottom.jpg";
import bottomImgMobile from "../../assets/images/feature-bottom-mobile.jpg";
import { Link } from "react-router-dom";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import MainFooter from "../../components/MainFooter/MainFooter";

function Features() {
  return (
    <div className={classes.main}>
      {/* hero */}
      <section className={classes.heroSection}>
        <picture>
          <source media="(max-width: 768px)" srcSet={heroMobile} />
          <source media="(min-width: 769px)" srcSet={hero} />
          <img src={hero} alt={hero} />
        </picture>
        <div className={classes.heroContent}>
          <div className={classes.heroContentWrapper}>
            <h1 className={classes.heroTitle}>
              After 2 years of spinning in circles, Jess was looking for a new
              direction. Then she found Bookalooza.
            </h1>
            <Link to="/newbook">
              <PrimaryButton className={classes.createButton}>
                Write Your Book Now
              </PrimaryButton>
            </Link>
          </div>
        </div>
      </section>

      <div className={classes.container}>
        <section className={classes.contentWrapper}>
          {features.map((item, idx) => (
            <FeatureCard
              key={item.key}
              title={item.title}
              bulletPoints={item.content}
              imageUrl={item.img}
              imageAlt={item.name}
              reverse={idx % 2 === 1}
            />
          ))}
        </section>
      </div>

      <section className={classes.bottomSection}>
        <picture>
          <source media="(max-width: 768px)" srcSet={bottomImgMobile} />
          <source media="(min-width: 769px)" srcSet={bottomImg} />
          <img src={bottomImg} alt={hero} />
        </picture>
        {/* <div className={classes.bottomContent}>
          <div className={classes.bottomContentWrapper}>
            <div className={classes.bottomHeader}>
              <h2>Unlock New Markets</h2>
              <p>
                Sell on <span>Amazon</span> and <span>Flipkart</span>!
              </p>
            </div>
            <div className={classes.bottomCards}>
              <article className={classes.card}>
                <h3>Reach Millions of Readers</h3>
                <p>
                  Listing on Amazon and Flipkart makes that dream a reality,
                  putting your book right where the readers are!
                </p>
              </article>
              <article className={classes.card}>
                <h3>Boost Your Credibility</h3>
                <p>
                  Readers trust these sites, so seeing your book there
                  automatically boosts its value and professionalism.
                </p>
              </article>
              <article className={classes.card}>
                <h3>Maximize Sales Potential</h3>
                <p>
                  With millions of people browsing Amazon and Flipkart every
                  day, your book has a better chance of being discovered and
                  purchased.
                </p>
              </article>
              <article className={classes.card}>
                <h3>Marketing Made Easy</h3>
                <p>
                  Both Amazon and Flipkart are already doing the heavy lifting
                  to get your book in front of the right audience!
                </p>
              </article>
              
            </div>
          </div>
        </div> */}
      </section>
      <MainFooter />
    </div>
  );
}

export default Features;
